import React from 'react';
import styled from 'styled-components';
import {isMobileOnly} from 'react-device-detect';


const EsOrderDoneDvryInfoBlock = styled.div``;

const EsOrderDoneDvryInfo = ({ esOrderInfo }) => {

    // Return Mobile Phone Number Format
    const getPhoneNumber = (item) => {

        if (item === null || item === undefined || item.length === 0) {
            return ""
        } else if (item.length < 11) {
            return item;
        } else {
            return (item.substr(0, 3) + "-" + item.substr(3, 4) + "-" + item.substr(7, 4));
        }

    }

    // 연락처 2
    const getRcvMo2 = () => {
        if (esOrderInfo.data.orderinfo.rv_mo_no2 === '010') {
            return '-';
        } else {
            return (getPhoneNumber(esOrderInfo.data.orderinfo.rv_mo_no2));
        }
    }

    const colSpan = isMobileOnly?"1":"3";

    return (
        <EsOrderDoneDvryInfoBlock>

            <div className="default-table margin_b-60">
                <h3 className="dt-title">배송지 정보</h3>

                <table>
                    {!isMobileOnly?
                    <colgroup>
                        <col width="180px;" />
                        <col width="410px;" />
                        <col width="180px;" />
                        <col width="410px;" />
                    </colgroup>
                    :
                      <colgroup>
                          <col width="40%" />
                          <col width="60%" />
                      </colgroup>

                    }

                    <tbody>
                        <tr>
                            <td className="gray">배송 주소</td>
                            <td colSpan={colSpan}>
                                <p>
                                    {esOrderInfo.data.orderinfo.rv_addr1} , {esOrderInfo.data.orderinfo.rv_addr2}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td className="gray">수령인</td>
                            <td colSpan={colSpan}><span>{esOrderInfo.data.orderinfo.rv_nm}</span></td>
                        </tr>
                        <tr>
                            <td className="gray">연락처1</td>
                            <td colSpan={colSpan}>
                                <span>{getPhoneNumber(esOrderInfo.data.orderinfo.rv_mo_no)}</span>
                            </td>
                        </tr>
                        <tr>
                            <td className="gray">연락처2</td>
                            <td colSpan={colSpan}>
                                <span>{getRcvMo2()}</span>
                            </td>
                        </tr>
                        <tr>
                            <td className="gray border_bottom">배송 요청사항</td>
                            <td colSpan={colSpan} className="border_bottom">
                                <span>{esOrderInfo.data.orderinfo.od_dlvry_memo}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </EsOrderDoneDvryInfoBlock>
    );
};

export default EsOrderDoneDvryInfo;
